import en from "./en";
import fa from "./fa";

export const dictionaries = { en, fa };
